/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Contact_Success_Responsetime1Inputs */

const he_contact_success_responsetime1 = /** @type {(inputs: Contact_Success_Responsetime1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`קיבלנו את ההודעה ונחזור אליך מהר ככל שנוכל.`)
};

const en_contact_success_responsetime1 = /** @type {(inputs: Contact_Success_Responsetime1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`We've received your message and will respond as soon as we can.`)
};

/**
* | output |
* | --- |
* | "We've received your message and will respond as soon as we can." |
*
* @param {Contact_Success_Responsetime1Inputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
const contact_success_responsetime1 = /** @type {((inputs?: Contact_Success_Responsetime1Inputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contact_Success_Responsetime1Inputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_contact_success_responsetime1(inputs)
	return en_contact_success_responsetime1(inputs)
});
export { contact_success_responsetime1 as "contact_success_responseTime" }